import { Grid, styled, StyledComponent } from '@valenzinsights/core-component';

export const cardLayoutGridExpStyle: React.CSSProperties = {
    justifyContent: "flex-start",
    alignItems: "flex-start",
    display: "block",
    maxHeight: "calc(100vh - 30px)",
    height: "100%",
    overflowY: "auto",
};

export const webChatStyle: React.CSSProperties = {
    width: "98.6%",
    height: "100%",
    bottom: "8px",
    left: "9px",
};

export const StyledWebChatModule: StyledComponent<any> = styled(Grid)(({ theme }) => {
    return ({
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        "& .webchat__css-custom-properties": {
            '[class^="webchat--css-"]': {
                backgroundColor: "transparent",
            },
        },
        ".webchat__send-box__main": {
            borderBottom: `3px solid ${theme.palette.secondary.main}`,
        },
        ".webchat__initialsAvatar__initials": {
            fontSize: "large",
        },
        ".ac-textInput, .ac-dateInput, .ac-multichoiceInput": {
            height: "30px !important",
            padding: "5px !important"
        },
        // stacked-layout
        ".webchat__stacked-layout__main": {
            flexDirection: "end",
            display: "flex",
            justifyContent: "flex-end",
            margin: "10px 0",
            maxWidth: "fit-content"
        },
        ".webchat__stacked-layout--from-user": {
            flexDirection: "row",
            textAlign: "-webkit-match-parent",
            direction: "rtl"
        },
        ".webchat__stacked-layout--from-user p": {
            direction: "ltr"
        },
        ".webchat__stacked-layout--from-user > .webchat__stacked-layout__status": {
            flexDirection: "rowReverse",
            direction: "ltr",
            marginRight: "-50px"
        },
        // components
        "img": {
            cursor: "pointer",
        },
        "textarea.ac-textInput": {
            height: "85px !important",
        },
        "textarea": {
            resize: "none !important",
        },
        "button": {
            cursor: "pointer",
            width: "fit-content",
            height: "31.33px",
            "&:hover": {
                backgroundColor: "rgba(0, 0, 0, 0.04)",
            },
            fontSize: theme.typography.body2.fontSize,
            borderRadius: 4
        },
        ".webchat__basic-transcript__scrollable": {
            scrollbarWidth: "thin",
            scrollbarColor: `${theme.palette.grey[100]} transparent`
        }

    })
}
);